<template>
  <div class="home" ref="home">
    <router-view></router-view>
    <div class="topBtn" :class="{'topBtn--show': topGap > 100}">
      <a title="返回最上面" v-scroll-to="{el: '#content'}">
        <span>
          <i class="fas fa-caret-up"></i>
          TOP
        </span>
      </a>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'Home',
  data() {
    return {
      topGap: 0
    }
  },
  methods: {
    listenScroll() {
      const vm = this;
      window.addEventListener("scroll", function() {
        vm.topGap = document.documentElement.scrollTop;
      })
    }
  },
  mounted() {
    this.listenScroll();
  },
}
</script>
